import React, { Component } from "react";
import "../styles/components/Switch.css";
class Switch extends Component {
  state = {
    langSelected: "al",
    lngSwitch: false
  };
  componentDidMount() {
    const lng = localStorage.getItem("language");
    this.setState({ langSelected: lng });
    if (lng === "al") {
      this.setState({ lngSwitch: false });
    } else if (lng === "en") {
      this.setState({ lngSwitch: true });
    }
  }
  changeLanguage = () => {
    if (document.getElementById("toggle").checked === true) {
      this.setState({ langSelected: "en", lngSwitch: true });
      localStorage.setItem("language", "en");
    } else {
      this.setState({ langSelected: "al", lngSwitch: false });
      localStorage.setItem("language", "al");
    }
    setTimeout(function() {
      window.location.reload();
    }, 800);
  };
  render() {
    return (
      <div className="toggle">
        <img className="alFlag" src="/images/al.png" alt="flamuri shqiptar" />
        <input
          type="checkbox"
          id="toggle"
          checked={this.state.lngSwitch}
          onChange={() => this.changeLanguage()}
        />
        <img className="ukFlag" src="/images/uk.png" alt="flamuri anglez" />
        <label for="toggle">
          <div className="slide" />
        </label>
      </div>
    );
  }
}
export default Switch;
